import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BeanUsuario } from 'src/bean/BeanUsuario';
import { environment } from 'src/environments/environment';

@Injectable()

export class CadastroUsuarioService {


    selectedIndex: number = 0;

    constructor(
        private http: HttpClient
    ){ }


    public getUsuarioPorId(id:number):Promise<any>{
        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.get(environment.urlBackend + environment.getUsuarioById + "/" + id, { headers : headers})
        .toPromise().then(
                (resposta:any) => resposta    );
    }

    public getUsuarioPorRe(re:string):Promise<any>{
        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.get(environment.urlBackend + environment.getUsuario + "/" + re, { headers : headers})
        .toPromise().then(
                (resposta:any) => resposta    );
    }

    public getUsuarioByName(usuaNmUsuario:string):Promise<any>{
        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.get(environment.urlBackend + environment.getUsuarioByName + "/" + usuaNmUsuario, { headers : headers})
        .toPromise().then(
                (resposta:any) => resposta    );
    }


    public getListcmbOperacao():Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.get(environment.urlBackend + environment.listarCadastroOperacoesAtivos, { headers : headers})
        .toPromise().then(
                (resposta:any) => resposta    );
    }



    public getListcmbMenu():Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.get(environment.urlBackend + environment.listarCadastroMenusAtivos, { headers : headers})
        .toPromise().then(
                (resposta:any) => resposta    );
    }


    public listarSituacao() : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarSituacaoPorOperacoes, {headers}).toPromise().then((resposta:any) => resposta)

    }


    public listarGestao(idOperacao : string) : Promise<any>{

        const tokenString = localStorage.getItem('access_token');
        let idTipoDeUsuarioGestor = "2"

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarGertorPorEmpresa + "/"+idOperacao + "/"+idTipoDeUsuarioGestor, {headers}).toPromise().then((resposta:any) => resposta)

    }




    public listartipoUsuario() : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarTipoUsuario, {headers}).toPromise().then((resposta:any) => resposta)

    }


    public listarGestor() : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarTipoUsuario, {headers}).toPromise().then((resposta:any) => resposta)

    }

    public listarUsuariosPorOperacoes(idOperacao : string) : Promise<any>{

        const tokenString = localStorage.getItem('access_token');

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type': 'application/json'
            };

        return this.http.get(environment.urlBackend +  environment.listarAllUsuariosOperacoes +"/"+ idOperacao, {headers}).toPromise().then((resposta:any) => resposta)

    }


    addUsuario(formModel: BeanUsuario):Promise<any>{
        return this.gravarUsuario(formModel).toPromise().then((resposta:any) => resposta);
    }

    public gravarUsuario(formModel: BeanUsuario):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        let json = JSON.stringify(formModel);


        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.post(environment.urlBackend + environment.criarUsuario, json, {headers: headers});
    }


    insertEmpresaParaUsuario(idUsuarioEdicao: string, idOperacao : string):Promise<any>{
        return this.gravarEmpresaParaUsuario(idUsuarioEdicao, idOperacao).toPromise().then((resposta:any) => resposta);
    }

    public gravarEmpresaParaUsuario(idUsuarioEdicao: string, idOperacao : string):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        let json = "{\"usuaIdCdUsuario\":\""+idUsuarioEdicao+"\",\"operIdCdOperacao\":\""+idOperacao+"\"}";

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.post(environment.urlBackend + environment.criarUsuarioPorEmpresa, json, {headers: headers});
    }




    insertEmpresaParaMenu(idUsuarioEdicao: string, idMenu : string):Promise<any>{
        return this.gravarEmpresaParaMenu(idUsuarioEdicao, idMenu).toPromise().then((resposta:any) => resposta);
    }

    public gravarEmpresaParaMenu(idUsuarioEdicao: string, idMenu : string):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        let json = "{\"usuaIdCdUsuario\":\""+idUsuarioEdicao+"\",\"menuIdCdMenu\":\""+idMenu+"\"}";

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.post(environment.urlBackend + environment.criarUsuarioPorMenu, json, {headers: headers});
    }



    deleteUsuarioParaMenu(idUsuarioEdicao: string, idMenu : string):Promise<any>{
        return this.excluirUsuarioParaMenu(idUsuarioEdicao, idMenu).toPromise();
    }

    public excluirUsuarioParaMenu(idUsuarioEdicao: string, idMenu : string):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        const options = {
            headers: new HttpHeaders({   'Authorization' : 'Bearer ' + tokenString,
                                         'Content-Type'  : 'application/json'}),
            body: {
                usuaIdCdUsuario: idUsuarioEdicao,
                menuIdCdMenu: idMenu,
            },
          };


        return this.http.delete(environment.urlBackend + environment.deletarUsuarioPorMenu, options);
    }



    deleteUsuarioParaOperacao(idUsuarioEdicao: string, idOperacao : string):Promise<any>{
        return this.excluirUsuarioParaOperacao(idUsuarioEdicao, idOperacao).toPromise().then((resposta:any) => resposta);
    }

    public excluirUsuarioParaOperacao(idUsuarioEdicao: string, idOperacao : string):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        const options = {
            headers: new HttpHeaders({   'Authorization' : 'Bearer ' + tokenString,
                                         'Content-Type'  : 'application/json'}),
            body: {
                usuaIdCdUsuario: idUsuarioEdicao,
                operIdCdOperacao: idOperacao,
            },
          };

        return this.http.delete(environment.urlBackend + environment.deletarUsuarioPorOperacao, options);
    }

    addOperacaoUsuario( idusuario: string, idOperacao: string ):Promise<any>{
        return this.gravarOperacaoUsuario(idOperacao, idusuario).toPromise().then((resposta:any) => resposta);
    }

    public gravarOperacaoUsuario(idOperacao: string, idusuario: string):Observable<any> {

        const tokenString = localStorage.getItem('access_token');

        let json = "{\"usuaIdCdUsuario\":\""+idusuario+"\",\"operIdCdOperacao\":\""+idOperacao+"\"}";



        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.post(environment.urlBackend + environment.criarEmpresaPorUsuario, json, {headers: headers});
    }



    updateUsuario(formModel: BeanUsuario):Promise<any>{
        return this.atualizarUsuario(formModel).toPromise().then((resposta:any) => resposta);
    }

    public atualizarUsuario(formModel: BeanUsuario):Observable<any> {
        const tokenString = localStorage.getItem('access_token');


        let json = JSON.stringify(formModel);

        const headers = {
            'Authorization' : 'Bearer ' + tokenString,
            'Content-Type' : 'application/json'
        }

        return this.http.put(environment.urlBackend + environment.updateUsuario + "/" +formModel.usuaIdCdUsuario +"/",  json, { headers : headers});

    }

}
